<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-container>
          <el-main>
            <h1>学生管理</h1>
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="学号">
                <el-input v-model="search.studentId" placeholder="请输入学号"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="search.studentName" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="performSearch">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="exportData">导出</el-button>
              </el-form-item>
            </el-form>
  
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="studentId" label="学号" width="180"></el-table-column>
              <el-table-column prop="grade" label="年级" width="180"></el-table-column>
              <el-table-column prop="name" label="姓名" width="180"></el-table-column>
              <el-table-column prop="enrollmentDate" label="入学时间" width="180"></el-table-column>
              <el-table-column prop="graduationDate" label="毕业时间" width="180"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
  
            <!-- 分页导航栏 -->
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: page === 1 }">
                  <button class="page-link" @click="changePage(page - 1)">上一页</button>
                </li>
                <li v-for="n in totalPages" :key="n" class="page-item" :class="{ active: page === n }">
                  <button class="page-link" @click="changePage(n)">{{ n }}</button>
                </li>
                <li class="page-item" :class="{ disabled: page === totalPages }">
                  <button class="page-link" @click="changePage(page + 1)">下一页</button>
                </li>
              </ul>
            </nav>
  
            <!-- 确认删除 Modal -->
            <el-dialog title="确认删除" :visible.sync="showConfirmDeleteModal">
              <span>你确定要删除学生 "{{ confirmDeleteStudent.name }}" 吗？</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="showConfirmDeleteModal = false">取消</el-button>
                <el-button type="danger" @click="deleteStudent">确认</el-button>
              </span>
            </el-dialog>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </template>

<script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';

export default {
  name: 'HomePage',
  components: {
    SideBar,
    TopBar
  },
  data() {
    return {
      search: {
        studentId: '',
        studentName: ''
      },
      tableData: [
      { studentId: '202001',grade: '一年级', name: '张三', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202002',grade: '一年级', name: '李四', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},     
      { studentId: '202003',grade: '一年级', name: '王五', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},
      { studentId: '202004',grade: '一年级', name: '赵六', enrollmentDate: '2020-09-01', graduationDate: '2024-07-01'},

        // 更多学生数据...
      ],
      page: 1,
      totalPages: 5,
      showConfirmDeleteModal: false,
      confirmDeleteStudent: {}
    };
  },
  methods: {
    performSearch() {
      // 搜索逻辑
      console.log('搜索学生:', this.search);
    },
    exportData() {
      // 导出逻辑
      console.log('导出学生数据');
    },
    handleEdit(index, row) {
      // 编辑逻辑
      console.log('编辑学生:', row);
    },
    handleDelete(index, row) {
      this.confirmDeleteStudent = row;
      this.showConfirmDeleteModal = true;
    },
    deleteStudent() {
      // 删除逻辑
      this.tableData = this.tableData.filter(s => s.studentId !== this.confirmDeleteStudent.studentId);
      this.showConfirmDeleteModal = false;
    },
    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPages) return;
      this.page = newPage;
      // 分页逻辑
      console.log('当前页:', this.page);
    }
  }
}
</script>

<style scoped>
/* .el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  width: 200px;
  height: 100vh;
} */

.el-main {
  background-color: #edf0f499;
  color: #333;
  text-align: center;
  padding: 20px;
}

.pagination {
  display: flex;
  justify-content: center;
  list-style: none;
  padding-left: 0;
  margin-top: 20px; /* 根据需要调整间距 */
}

.page-item {
  margin-right: 5px; /* 分页项目之间的间距 */
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.page-item.active .page-link {
  font-weight: bold;
  color: #fff;
  background-color: #c4bdbd;
  border-color: #d5d6d7;
}
</style>